import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-selected",
  "use": "icon-selected-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" class=\"design-iconfont\" id=\"icon-selected\">\n  <g fill=\"none\" fill-rule=\"evenodd\">\n    <path fill=\"#E8AB79\" d=\"M8 0A8 8 0 1 0 8 16A8 8 0 1 0 8 0Z\" />\n    <path stroke=\"#FFF\" stroke-width=\"2\" stroke-linejoin=\"round\" d=\"M5 7.77639557L7.5230006 10.2993962 11.8223968 6\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol